module.exports = __webpack_public_path__ + "static/media/h1.055c5043.PNG";